import GoogleMapReact from 'google-map-react'
import React from 'react'
import PropTypes from 'prop-types'
import envs from '@/constants/envs'
import { Container, Marker } from './styles'

function MapLocation({ sameCity, location }) {
  return (
    <Container>
      <GoogleMapReact
        bootstrapURLKeys={{ key: envs.REACT_APP_GOOGLE_MAPS_API_KEY }}
        defaultCenter={{
          lat: location?.coordinates[1],
          lng: location?.coordinates[0],
        }}
        defaultZoom={16}
        draggable={false}
        options={{ fullscreenControl: null }}
      >
        <Marker
          sameCity={sameCity}
          lat={location?.coordinates[1]}
          lng={location?.coordinates[0]}
        />
      </GoogleMapReact>
    </Container>
  )
}

MapLocation.propTypes = {
  location: PropTypes.objectOf(Object).isRequired,
  sameCity: PropTypes.bool.isRequired,
}

export default MapLocation
